<script>
  import "daterangepicker";
  import { onMount } from "svelte";
  import { translator } from "../../store";
  export let label = "";
  export let fieldName = "";
  export let required = false;
  export let value = null;
  export let defaultStart;
  export let defaultEnd;
  let uniqueID = Math.random().toString(36).slice(2, 12);
  export let onChange = () => null;

  onMount(() => {
    window.jQuery(`#${uniqueID}`).daterangepicker(
      {
        startDate: defaultStart,
        endDate: defaultEnd,
        opens: "left",
        locale: {
          format: "DD MMM yy",
          separator: " - ",
          applyLabel: translator("Apply"),
          cancelLabel: translator("Cancel"),
          fromLabel: translator("From"),
          toLabel: translator("To"),
          customRangeLabel: translator("Custom"),
          daysOfWeek: [
            translator("Day_Sun"),
            translator("Day_Mon"),
            translator("Day_Tue"),
            translator("Day_Wed"),
            translator("Day_Thu"),
            translator("Day_Fri"),
            translator("Day_Sat")
          ],
          monthNames: [
            translator("January"),
            translator("February"),
            translator("March"),
            translator("April"),
            translator("May"),
            translator("June"),
            translator("July"),
            translator("August"),
            translator("September"),
            translator("October"),
            translator("November"),
            translator("December"),
          ],
        },
      },
      onChange
    );
  });
</script>

<div>
  {#if label}
    <label class="form-label" for={uniqueID}>
      {label}
      {#if required}
        <span class="text-red">*</span>
      {/if}
    </label>
  {/if}
  <input
    class="form-control input-daterange-datepicker text-center"
    type="text"
    name={fieldName}
    id={uniqueID}
    bind:value
    style="min-width: 200px; cursor: pointer"
  />
</div>
